import React from "react";
import styled from "styled-components";
import icons from "./icons";
import Icon from "./icon";

const colorMap = (p) => ({
	confirm: {
		color: p.theme.main,
		text: p.theme.white,
		hover: true,
	},
	select: {
		color: p.theme.slight,
		text: p.theme.white,
		hover: true,
	},
	cancel: {
		color: p.theme.warn,
		text: p.theme.white,
		hover: true,
	},
	white: {
		color: p.theme.white,
		text: p.theme.main,
		hover: true,
	},
});

const Button = (props) => (
	<Wrapper
		disabled = { !props.active }
		{ ...props }
	>
		{
			props.icon && (
				<Icon
					type = { props.icon }
					color = { colorMap(props)[props.type.toLowerCase()].text }
					input
				/>
			)
		}
		{ props.children || props.text }
	</Wrapper>
);

Button.propTypes = {
	children: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.element,
	]),

	onClick: React.PropTypes.func.isRequired,
	type: React.PropTypes.oneOf([
		"SELECT",
		"CONFIRM",
		"CANCEL",
		"WHITE",
	]),
	icon: React.PropTypes.oneOf(icons),
	fullWidth: React.PropTypes.bool,
	text: React.PropTypes.string,
	active: React.PropTypes.bool,
};

Button.defaultProps = {
	active: true,
	theme: theme,
	type: "SELECT",
};

const Wrapper = styled.button`
	${common.inputAndButton}
	cursor: pointer;
	position: relative;
	font-weight: bold;
	text-transform: uppercase;
	transition: 0.1s all linear;
	${p => p.icon && !p.fullWidth && `padding-left: ${3 - 0.4}em;`}
	${p => p.fullWidth && "width: 100%;"}
	${
		p => {
			const o = colorMap(p)[p.type.toLowerCase()];
			const disableColor = mixins.darken(o.color, 0.2);

			return `
				background-color: ${p.active ? o.color : disableColor};
				color: ${p.active ? o.text : mixins.mix(disableColor, o.text)};
				${
					(p.active && o.hover)
					&& `
						&:hover,
						&:active {
							background-color: ${mixins.darken(o.color)}
						}
					`
				}
			`;
		}
	}
`;

export default Button;
